import type { ValueOf } from '../util/typeUtils';

export const SYSTEM_VARIABLE_COMMANDS = {
    updateBucketDistribution: 'updateBucketDistribution',
} as const;

export type SYSTEM_VARIABLE_COMMAND = ValueOf<typeof SYSTEM_VARIABLE_COMMANDS>;
